import React from "react";
import PayrollRomms from "../../payroll/PayrollRomms";

interface BorrIndASRommsProps {
  onBack: () => void;
}

export default function BorrIndASRomms({ onBack }: BorrIndASRommsProps) {
  return <PayrollRomms onBack={onBack} onComplete={() => {}} workspace="Borrowings - Ind AS" />;
}

